import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiServices } from "../../service/apiServices";

const namespace = "Personnel";

export const postPersonnel = createAsyncThunk(
  `${namespace}/postPersonnel`,
  async (body, { rejectWithValue }) => {
    const api = "personnelList";
    const opt = {
      body: { searchText: body },
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postPersonnelByPerson = createAsyncThunk(
  `${namespace}/postPersonnelByPerson`,
  async (body, { rejectWithValue }) => {
    const api = "personnelByPerson";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postPersonnelExcel = createAsyncThunk(
  `${namespace}/postPersonnelExcel`,
  async (body, { rejectWithValue }) => {
    const api = "personnelexcel";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const postPersonnelPDF = createAsyncThunk(
  `${namespace}/postPersonnelPDF`,
  async (body, { rejectWithValue }) => {
    const api = "personnelpdf";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const addReasonLate = createAsyncThunk(
  `${namespace}/reasonadd`,
  async (body, { rejectWithValue }) => {
    const api = "reasonadd";
    const opt = {
      body: body,
    };

    try {
      const response = await apiServices(api, opt);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

const initialState = {
  id: "",
  fullname: "",
  personnelReport: {
    persons: {
      id: "",
    },
    fromdate: new Date(Date.now() - 86400000).toISOString().slice(0, 10),
    todate: new Date().toISOString().slice(0, 10),
  },
  leaveTaken:{
    sid:"",
    from_date: new Date(Date.now() - 86400000).toISOString().slice(0, 10),
    to_date: new Date().toISOString().slice(0, 10),
  },
  personnels: [],
  reason: {
    date: "",
    id: "",
    reason_late: ""
  }
};

const personnelSlice = createSlice({
  name: "person",
  initialState,
  reducers: {
    // updatePersonnel(state, action) {
    //   console.log(action.payload);
    //   const a = {
    //     ...state,
    //     fullname: action.payload,
    //   };

    //   return a;
    // },
    updatePersonnelReport(state, action) {
      return { ...state, personnelReport: action.payload };
    },
    resetPersonnelReport(state, action) {
      return { ...state, personnelReport: initialState.personnelReport};
    },
    updateLeaveTaken(state, action) {
      return { ...state, leaveTaken: action.payload };
    },
    resetLeaveTaken(state, action) {
      return { ...state, leaveTaken: initialState.leaveTaken};
    },
    updateReason(state, action) {
      return { ...state, reason: action.payload };
    },
    resetReason(state, action) {
      return { ...state, reason: initialState.reason};
    },
  },

  extraReducers: {
    [postPersonnel.pending]: (state, action) => {
      state.loading = true;
    },

    [postPersonnel.fulfilled]: (state, action) => {
      state.loading = false;

      state.personnels = [];
      let _personnels = [...state.personnels, ...action.payload];

      const updatedArr = _personnels.map((obj) => {
        return {
          value: obj.id,
          value2:obj.s_id,
          label: obj.fullname,
        };
      });

      state.personnels = [...state.personnels, ...updatedArr];
      console.log(state.personnels);
    },

    [postPersonnel.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },

    [postPersonnelByPerson.pending]: (state, action) => {
      state.loading = true;
    },
    [postPersonnelByPerson.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postPersonnelByPerson.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [postPersonnelExcel.pending]: (state, action) => {
      state.loading = true;
    },
    [postPersonnelExcel.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postPersonnelExcel.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
    [postPersonnelPDF.pending]: (state, action) => {
      state.loading = true;
    },
    [postPersonnelPDF.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [postPersonnelPDF.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },

    [addReasonLate.pending]: (state, action) => {
      state.loading = true;
    },
    [addReasonLate.fulfilled]: (state, action) => {
      state.loading = false;
      console.log(action.payload);
    },
    [addReasonLate.rejected]: (state, action) => {
      state.error = true;
      console.error(action.payload);
    },
  },
});

export const { updatePersonnelReport, resetPersonnelReport, updateLeaveTaken, resetLeaveTaken, updateReason, resetReason } =
  personnelSlice.actions;
export default personnelSlice.reducer;

// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { apiServices } from "../../service/apiServices";

// const namespace = "Personnel";

// export const postPersonnel = createAsyncThunk(
//   `${namespace}/postPersonnel`,
//   async (body, { rejectWithValue }) => {
//     const api = "personnelList";
//     const opt = {
//       body: { searchText: body },
//     };

//     try {
//       const response = await apiServices(api, opt);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err);
//     }
//   }
// );

// export const postPersonnelByPerson = createAsyncThunk(
//   `${namespace}/postPersonnelByPerson`,
//   async (body, { rejectWithValue }) => {
//     const api = "personnelByPerson";
//     const opt = {
//       body: body,
//     };

//     try {
//       const response = await apiServices(api, opt);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err);
//     }
//   }
// );

// export const postPersonnelExcel = createAsyncThunk(
//   `${namespace}/postPersonnelExcel`,
//   async (body, { rejectWithValue }) => {
//     const api = "personnelexcel";
//     const opt = {
//       body: body,
//     };

//     try {
//       const response = await apiServices(api, opt);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err);
//     }
//   }
// );

// const initialState = {
//   id: "",
//   fullname: "",
//   personnelReport: {
//     persons: {
//       id: "",
//     },
//     fromdate: new Date(Date.now() - 86400000).toISOString().slice(0, 10),
//     todate: new Date().toISOString().slice(0, 10),
//   },
//   leaveTaken:{
//     sid:"",
//     from_date: new Date(Date.now() - 86400000).toISOString().slice(0, 10),
//     to_date: new Date().toISOString().slice(0, 10),
//   },
//   personnels: [],
// };

// const personnelSlice = createSlice({
//   name: "person",
//   initialState,
//   reducers: {
//     // updatePersonnel(state, action) {
//     //   console.log(action.payload);
//     //   const a = {
//     //     ...state,
//     //     fullname: action.payload,
//     //   };

//     //   return a;
//     // },
//     updatePersonnelReport(state, action) {
//       return { ...state, personnelReport: action.payload };
//     },
//     resetPersonnelReport(state, action) {
//       return { ...state, personnelReport: initialState.personnelReport};
//     },
//     updateLeaveTaken(state, action) {
//       return { ...state, leaveTaken: action.payload };
//     },
//     resetLeaveTaken(state, action) {
//       return { ...state, leaveTaken: initialState.leaveTaken};
//     },
//   },

//   extraReducers: {
//     [postPersonnel.pending]: (state, action) => {
//       state.loading = true;
//     },

//     [postPersonnel.fulfilled]: (state, action) => {
//       state.loading = false;

//       state.personnels = [];
//       let _personnels = [...state.personnels, ...action.payload];

//       const updatedArr = _personnels.map((obj) => {
//         return {
//           value: obj.id,
//           value2:obj.personnel_id,
//           label: obj.fullname,
//         };
//       });

//       state.personnels = [...state.personnels, ...updatedArr];
//       console.log(state.personnels);
//     },

//     [postPersonnel.rejected]: (state, action) => {
//       state.error = true;
//       console.error(action.payload);
//     },

//     [postPersonnelByPerson.pending]: (state, action) => {
//       state.loading = true;
//     },
//     [postPersonnelByPerson.fulfilled]: (state, action) => {
//       state.loading = false;
//       console.log(action.payload);
//     },
//     [postPersonnelByPerson.rejected]: (state, action) => {
//       state.error = true;
//       console.error(action.payload);
//     },
//     [postPersonnelExcel.pending]: (state, action) => {
//       state.loading = true;
//     },
//     [postPersonnelExcel.fulfilled]: (state, action) => {
//       state.loading = false;
//       console.log(action.payload);
//     },
//     [postPersonnelExcel.rejected]: (state, action) => {
//       state.error = true;
//       console.error(action.payload);
//     },
//   },
// });

// export const { updatePersonnelReport, resetPersonnelReport, updateLeaveTaken, resetLeaveTaken } =
//   personnelSlice.actions;
// export default personnelSlice.reducer;
